
import Vue from 'vue';
export default Vue.extend({
  props: {
    text: {
      type: String,
      default: 'Lorem Ipsum Dolor sit',
    },
    fontStyle: {
      type: String,
      default: 'h1',
    },
    level: {
      type: String,
      default: 'h2',
    },
  },
  data() {
    return {};
  },
});
